import { Component, OnDestroy, OnInit } from '@angular/core';
import { BmsjHipsterSharedCommonModule, BmsjHipsterSharedModule } from '../../../../shared';
import { CoreUtilsModule } from '../../../../shared/core-utils';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ObservationVariable } from '../../../../shared/model/observation-variable.model';
import { SubscriptionsManager } from '../../../../shared/util/subscriptions-manager';
import { DatasetService } from '../../../../shared/dataset/service/dataset.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'jhi-edit-variable-alias-modal',
    standalone: true,
    imports: [
        BmsjHipsterSharedCommonModule,
        BmsjHipsterSharedModule,
        CoreUtilsModule,
        FormsModule,
        NgIf,
        TranslateModule
    ],
    template: `
        <jhi-modal [title]="'study-editor.variable.table.edit.alias.modal.title' | translate">
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <form name="form" #f="ngForm">
                            <div class="mb-3 row">
                                <div class="col">
                                    <span jhiTranslate="study-editor.variable.table.edit.alias.modal.description" [translateValues]="{param: observationVariable?.name}"></span>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <div class="col">
                                    <input type="text" class="form-control" name="textAlias" id="textAlias"
                                           [(ngModel)]="observationVariable.alias" #textAlias="ngModel" required [maxlength]="ALIAS_TEXT_LIMIT" [pattern]="NAME_ALIAS_PATTERN"
                                           autocomplete="off">
                                    <div class="invalid-feedback d-block" *ngIf="textAlias.invalid">
                                        <span jhiTranslate="study-editor.variable.table.edit.alias.modal.alias.error"></span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" [disabled]="isSaving" (click)="dismiss()">
                    <span class="fa fa-ban me-1"></span><span jhiTranslate="cancel"></span>
                </button>
                <button (click)="save()" [disabled]="isSaving || f.form.invalid" class="btn btn-primary">
                    @if (isSaving) {
                        <span class="throbber throbber-btn"></span>
                    }
                    <span class="fa fa-save me-1"></span><span jhiTranslate="save"></span>
                </button>
            </div>
        </jhi-modal>
    `,
    styleUrl: './edit-variable-alias-modal.component.scss'
})
export class EditVariableAliasModalComponent implements OnInit, OnDestroy {

    protected readonly ALIAS_TEXT_LIMIT = 32;
    protected readonly NAME_ALIAS_PATTERN = /^[\p{L}][\p{L}0-9_]*$/u;

    public studyId: number;
    public datasetId: number;
    public observationVariable: ObservationVariable;

    private subscriptionsManager: SubscriptionsManager = new SubscriptionsManager();

    protected originalVariableAlias: string;
    protected isSaving: boolean = false;

    constructor(private modal: NgbActiveModal,
                private datasetService: DatasetService) {
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.originalVariableAlias = this.observationVariable?.alias;
    }

    protected dismiss() {
        // If cancel, restore original alias and dismiss modal
        this.observationVariable.alias = this.originalVariableAlias;
        this.modal.dismiss();
    }

    protected save() {

        // Check first if alias has changed
        if (this.originalVariableAlias !== this.observationVariable?.alias) {
            this.isSaving = true;
            this.subscriptionsManager.add = this.datasetService.updateVariableAlias(this.studyId, this.datasetId, this.observationVariable).pipe(finalize(() => {
                this.isSaving = false;
            })).subscribe(() => {
                this.modal.close(this.observationVariable);
                this.isSaving = false;
            });
        } else {
            this.modal.dismiss();
        }

    }
}
